import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AnalyticsDashboard } from './pages/AnalyticsDashboard';
import { Procedures } from './pages/Procedures';
import { MenuManagement } from './pages/MenuManagement';
import { Setup } from './pages/Setup';
import { Customers } from './pages/Customers';
// Team Operations
import { ShiftPlanner } from './pages/operations/team/ShiftPlanner';
import { LeaveTimeline } from './pages/operations/team/LeaveTimeline';
import { TeamDirectory } from './pages/operations/team/TeamDirectory';
import { Performance as TeamPerformance } from './pages/operations/team/Performance';
import { Costs as TeamCosts } from './pages/operations/team/Costs';
// Location Operations
import { Overview } from './pages/operations/locations/Overview';
import { Capacity } from './pages/operations/locations/Capacity';
import { Performance as LocationPerformance } from './pages/operations/locations/Performance';
import { Costs as LocationCosts } from './pages/operations/locations/Costs';
import { Settings as LocationSettings } from './pages/operations/locations/Settings';
// Orders
import { LiveQueue } from './pages/orders/LiveQueue';
import { Flagged } from './pages/orders/Flagged';
import { OrderHistory } from './pages/orders/OrderHistory';
import { Analytics as OrderAnalytics } from './pages/orders/Analytics';
// Menu Management
import { Products } from './pages/menu/Products';
import { Categories } from './pages/menu/Categories';
import { Modifiers } from './pages/menu/Modifiers';
import { Combos } from './pages/menu/Combos';
import { Stock } from './pages/menu/Stock';
import { Promotions } from './pages/menu/Promotions';
import { Performance as MenuPerformance } from './pages/menu/Performance';
// Procedures
import { Library } from './pages/procedures/Library';
import { AIAgents } from './pages/procedures/AIAgents';
import { Onboarding } from './pages/procedures/Onboarding';
import { Analytics as ProceduresAnalytics } from './pages/procedures/Analytics';
// Customers
import { Overview as CustomerOverview } from './pages/customers/Overview';
import { Database as CustomerDatabase } from './pages/customers/Database';
import { Segments as CustomerSegments } from './pages/customers/Segments';
import { Reviews as CustomerReviews } from './pages/customers/Reviews';
import { Insights as CustomerInsights } from './pages/customers/Insights';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<AnalyticsDashboard data-id="element-4" />} data-id="element-3" />

          {/* Operations: Team */}
          <Route path="/operations/team" element={<ShiftPlanner data-id="element-6" />} data-id="element-5" />
          <Route path="/operations/team/leave" element={<LeaveTimeline data-id="element-8" />} data-id="element-7" />
          <Route path="/operations/team/directory" element={<TeamDirectory data-id="element-10" />} data-id="element-9" />
          <Route path="/operations/team/performance" element={<TeamPerformance data-id="element-12" />} data-id="element-11" />
          <Route path="/operations/team/costs" element={<TeamCosts data-id="element-14" />} data-id="element-13" />

          {/* Operations: Locations */}
          <Route path="/operations/locations" element={<Overview data-id="element-16" />} data-id="element-15" />
          <Route path="/operations/locations/capacity" element={<Capacity data-id="element-18" />} data-id="element-17" />
          <Route path="/operations/locations/performance" element={<LocationPerformance data-id="element-20" />} data-id="element-19" />
          <Route path="/operations/locations/costs" element={<LocationCosts data-id="element-22" />} data-id="element-21" />
          <Route path="/operations/locations/settings" element={<LocationSettings data-id="element-24" />} data-id="element-23" />

          {/* Redirect old routes */}
          <Route path="/team" element={<Navigate to="/operations/team" replace data-id="element-26" />} data-id="element-25" />

          {/* Orders */}
          <Route path="/orders" element={<LiveQueue data-id="element-28" />} data-id="element-27" />
          <Route path="/orders/flagged" element={<Flagged data-id="element-30" />} data-id="element-29" />
          <Route path="/orders/history" element={<OrderHistory data-id="element-32" />} data-id="element-31" />
          <Route path="/orders/analytics" element={<OrderAnalytics data-id="element-34" />} data-id="element-33" />

          {/* Menu Management */}
          <Route path="/menu" element={<Products data-id="element-36" />} data-id="element-35" />
          <Route path="/menu/categories" element={<Categories data-id="element-38" />} data-id="element-37" />
          <Route path="/menu/modifiers" element={<Modifiers data-id="element-40" />} data-id="element-39" />
          <Route path="/menu/combos" element={<Combos data-id="element-42" />} data-id="element-41" />
          <Route path="/menu/stock" element={<Stock data-id="element-44" />} data-id="element-43" />
          <Route path="/menu/promotions" element={<Promotions data-id="element-46" />} data-id="element-45" />
          <Route path="/menu/performance" element={<MenuPerformance data-id="element-48" />} data-id="element-47" />

          {/* Procedures */}
          <Route path="/procedures" element={<Library data-id="element-50" />} data-id="element-49" />
          <Route path="/procedures/ai-agents" element={<AIAgents data-id="element-52" />} data-id="element-51" />
          <Route path="/procedures/onboarding" element={<Onboarding data-id="element-54" />} data-id="element-53" />
          <Route path="/procedures/analytics" element={<ProceduresAnalytics data-id="element-56" />} data-id="element-55" />

          {/* Setup */}
          <Route path="/setup" element={<Setup data-id="element-58" />} data-id="element-57" />

          {/* Customers */}
          <Route path="/customers" element={<CustomerOverview data-id="element-60" />} data-id="element-59" />
          <Route path="/customers/database" element={<CustomerDatabase data-id="element-62" />} data-id="element-61" />
          <Route path="/customers/segments" element={<CustomerSegments data-id="element-64" />} data-id="element-63" />
          <Route path="/customers/reviews" element={<CustomerReviews data-id="element-66" />} data-id="element-65" />
          <Route path="/customers/insights" element={<CustomerInsights data-id="element-68" />} data-id="element-67" />
        </Routes>
      </Layout>
    </Router>;
}